import { programs } from './programs'
import { recentActivity } from './recent-activity'
import { base } from './root'
import { suspensions } from './suspensions'
import { MSMySuspensionsKey } from './suspensions/useMySuspensions'
import { tasksReview } from './task-reviews'
import { MSTasksReviewByIdKey } from './task-reviews/useGetById'
import { trainingModules } from './training-modules'
import { trainingResets } from './training-resets'
import { MSMyTrainingResetsKey } from './training-resets/useMyTrainingResets'

const missionSpecialist = {
  programs,
  tasksReview,
  trainingModules,
  recentActivity,
  suspensions,
  trainingResets,
  ...base,
  keys: {
    MSTasksReviewByIdKey,
    MSMySuspensionsKey,
    MSMyTrainingResetsKey,
  },
}

export default missionSpecialist
